import About from "./sections/about/about";
import Activities from "./sections/activities/activities";
import Faq from "./sections/faq/faq";
import JapanTips from "./sections/tips/japan-tips";
import Reviews from "./sections/reviews/reviews";
import ExploreNav from "./sections/components/explore-nav";
import Footer from "./sections/components/footer/footer";
import Hero from "./sections/hero/hero";
import SakuraDivider from "./sections/components/sakura-divider";
import StatsBand from "./sections/about/stats-band";
import { usePageMeta } from "./utils/seo";

// ГЛАВНАЯ СТРАНИЦА.
//
// Порядок блоков — это порядок вопросов в голове у человека:
//   что вы за компания (Hero) → почему вам верить (цифры) →
//   что можно купить (Туры) →
//   кто вы такие (О нас) → как там всё устроено (быт) →
//   что говорят съездившие (Отзывы) →
//   а что если… (FAQ) →
//   как с вами связаться (подвал).
//
// Разделители идут по японскому году: сакура (весна) выше, момидзи
// (осенний клён) ниже. Кроме красоты у них есть работа — развести
// соседние фотофоны, чтобы кадры не стыковались встык.
const MainPage = () => {
  usePageMeta({
    title: "Туры в Японию из Казахстана",
    description:
      "Авторские туры по Японии, кампус-туры по университетам, визы, гид-сопровождение и маршруты под ключ. Оставьте заявку — подберём поездку.",
  });

  return (
    // gap-y был 10/16 (40 и 64 px). Вместе с отступами самой секции туров
    // между подзаголовком первого экрана и словами «Ближайшие туры»
    // набиралось больше двухсот пикселей пустого тёмного поля.
    <div className="w-full min-h-screen bg-kj-dark text-kj-ink flex flex-col justify-center items-center gap-y-5 sm:gap-y-8">
      <Hero />
      <SakuraDivider variant="left" season="sakura" />
      {/* Цифры компании стоят ровно на переходе от первого экрана к турам:
          человек уже заинтересовался, но перед ценой хочет понять, кто мы. */}
      <StatsBand />
      <Activities />
      <SakuraDivider variant="right" season="momiji" />
      <About />
      {/* Шесть карточек японского быта. Стоят между «о нас» и вопросами не
          случайно: человек уже поверил компании и как раз начинает думать
          не о цене, а о том, как он будет там жить эти девять дней. */}
      <JapanTips />
      {/* Отзывы стоят перед вопросами: сначала человек видит чужой опыт,
          и только потом идёт выяснять детали. Скриншоты переписок убеждают
          сильнее любого нашего текста — их и показываем. */}
      <Reviews />
      <SakuraDivider variant="center" season="momiji" />
      <Faq />
      {/* Развилка на подстраницы — последнее, что человек видит перед
          подвалом: к этому месту он уже знает, что мы за компания, и
          выбирает, куда идти дальше. */}
      <ExploreNav />
      <Footer />
    </div>
  );
};

export default MainPage;
